/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { QuestionLibraryApproveEditorViewModel } from "../types/QuestionLibraryApproveEditorViewModel.ts";

export const questionLibraryApproveEditorViewModelSchema = z.object({
  id: z.optional(
    z
      .number()
      .int()
      .describe(
        "ID da questão a ser aprovada ou rejeitada no banco de questões.",
      ),
  ),
  isApprover: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o usuário autenticado possui permissão de aprovador para esta questão.",
      ),
  ),
  label: z
    .string()
    .describe("Enunciado da questão (pode conter HTML). Opcional.")
    .nullish(),
  status: z.optional(
    z
      .number()
      .int()
      .describe(
        "Status de aprovação a ser definido para a questão.  Enum EExamItemStatus: `1` = Pending, `2` = Approved, `3` = Rejected.",
      ),
  ),
  statusDescription: z
    .string()
    .describe("Descrição textual do status de aprovação da questão. Opcional.")
    .nullish(),
  statusJustification: z
    .string()
    .describe(
      "Justificativa para a aprovação ou rejeição da questão. Opcional.",
    )
    .nullish(),
}) as unknown as ToZod<QuestionLibraryApproveEditorViewModel>;
